// @pushrocks scope
import * as smartpromise from '@push.rocks/smartpromise';

export { smartpromise };

// third parties;
import * as croner from 'croner';
// date-fns' root entry loads every one of its functions, about a second on Node; smarttime uses one
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow';
import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday.js';
import prettyMs from 'pretty-ms';

dayjs.extend(isToday);

const dateFns = { formatDistanceToNow };

export { croner, dateFns, dayjs, prettyMs };
